import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';

function CookiesAccept(){
    const [consent, setConsent] = useState(!Cookies.get('cookieConsent'));
    const { t } = useTranslation();

    const handleConsent = () => {
      Cookies.set('cookieConsent', true, { expires: 365 * 10 });
      setConsent(false);
    };

    if (!consent) {
      return null;
    }

    return(
        <div className="cookies">
            <p>{t("cookies_text")}</p>
            <button onClick={handleConsent}>{t("cookies_accept")}</button>
        </div>
    )
}
export default CookiesAccept;
